export default "__VITE_ASSET__GpQmGFC3__"